const professions = [
  "Dentistry",
  "Dietetics",
  "Medicine",
  "Nursing",
  "Occupational Therapy",
  "Optometry",
  "Pharmacy",
  "Physiotherapy",
  "Podiatry",
  "Radiography",
  "Speech Pathology",
  "Veterinary Science",
];

export default professions;
